var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 0.333344C10.6817 0.333344 13.6663 3.31801 13.6663 7.00001C13.6663 10.682 10.6817 13.6667 6.99967 13.6667C3.31767 13.6667 0.333008 10.682 0.333008 7.00001C0.333008 3.31801 3.31767 0.333344 6.99967 0.333344ZM6.99967 1.66668C5.58519 1.66668 4.22863 2.22858 3.22844 3.22877C2.22824 4.22897 1.66634 5.58552 1.66634 7.00001C1.66634 8.4145 2.22824 9.77105 3.22844 10.7712C4.22863 11.7714 5.58519 12.3333 6.99967 12.3333C8.41416 12.3333 9.77072 11.7714 10.7709 10.7712C11.7711 9.77105 12.333 8.4145 12.333 7.00001C12.333 5.58552 11.7711 4.22897 10.7709 3.22877C9.77072 2.22858 8.41416 1.66668 6.99967 1.66668ZM6.99967 3.00001C7.16296 3.00003 7.32057 3.05998 7.44259 3.16849C7.56461 3.27699 7.64257 3.42651 7.66167 3.58868L7.66634 3.66668V6.72401L9.47101 8.52868C9.59057 8.64865 9.65999 8.80963 9.66516 8.97893C9.67033 9.14823 9.61086 9.31315 9.49884 9.4402C9.38682 9.56724 9.23064 9.64688 9.06202 9.66294C8.89341 9.679 8.725 9.63028 8.59101 9.52668L8.52834 9.47134L6.52834 7.47134C6.42473 7.36764 6.35818 7.23268 6.33901 7.08734L6.33301 7.00001V3.66668C6.33301 3.48987 6.40325 3.3203 6.52827 3.19527C6.65329 3.07025 6.82286 3.00001 6.99967 3.00001Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeClock);
export default __webpack_public_path__ + "static/media/orange-clock.15141ed0b770a431add1800de90d1c04.svg";
export { ForwardRef as ReactComponent };